var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Toggle', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var onClick = _ref.onClick,
            isActive = _ref.isActive;
        return [_c('div', {
          ref: "question",
          staticClass: "bonus__question",
          class: [{
            bonus__question_show: isActive
          }]
        }, [_c('div', {
          staticClass: "bonus__question-wrap"
        }, [_c('p', {
          staticClass: "bonus__question-title"
        }, [_vm._v("\n          " + _vm._s(_vm.item.question) + "\n        ")]), _vm._v(" "), _vm.item.question.length ? _c('p', {
          staticClass: "bonus__question-desc"
        }, [_vm._v("\n          Ответ\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "bonus__question-answer",
          domProps: {
            "innerHTML": _vm._s(_vm.item.answer)
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "bonus__question-ellipse"
        })]), _vm._v(" "), _c('div', {
          staticClass: "bonus__question-overlay",
          class: [{
            'bonus__question-overlay_show': isActive
          }, {
            'bonus__question-overlay_hide': _vm.overflow < _vm.paddingY - 5
          }]
        }, [_c('button', {
          staticClass: "bonus__question-link",
          class: [{
            'bonus__question-link_show': isActive
          }],
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return onClick.apply(null, arguments);
            }
          }
        }, [_vm._v("\n          " + _vm._s(isActive ? 'Свернуть' : 'Развернуть') + "\n          "), _c('img', {
          staticClass: "bonus__question-link-img",
          attrs: {
            "src": isActive ? require('~/assets/images/bonus/path-top.svg') : require('~/assets/images/bonus/path-down.svg')
          }
        })])])])];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }